export default (options) => {
  let toastBox = document.getElementById('toast');

  if (toastBox === null) {
    toastBox = document.createElement('div');
    toastBox.id = 'toast';
    if (options.parent === undefined) {
      options.parent = 'body';
    }
    document.querySelector(options.parent).append(toastBox);
  }

  const toast = document.createElement('div');
  toast.classList.add('toast');
  toastBox.append(toast);

  let isClosing = false;
  const dismiss = () => {
    if (isClosing) return;
    isClosing = true;
    toast.classList.remove('show');
    setTimeout(() => { toast.remove(); }, 500);
  };

  const close = document.createElement('i');
  close.classList.add('fa-solid');
  close.classList.add('fa-xmark');
  close.addEventListener('click', (e) => {
    e.stopPropagation();
    dismiss();
  });
  toast.append(close);

  const types = ['error', 'info', 'warning', 'success'];
  if (options.type !== undefined && types.indexOf(options.type) >= 0) {
    const icon = document.createElement('span');
    icon.classList.add('toast-icon');
    icon.classList.add(`toast-icon-${options.type}`);

    const glyph = document.createElement('i');
    const iconByType = {
      error: 'fa-solid fa-xmark',
      info: 'fa-solid fa-info',
      warning: 'fa-solid fa-exclamation',
      success: 'fa-solid fa-check'
    };
    glyph.className = iconByType[options.type];
    glyph.classList.add('toast-icon-glyph', `toast-icon-glyph-${options.type}`);
    icon.append(glyph);

    const content = document.createElement('div');
    content.classList.add('toast-content');
    content.innerHTML = options.message;

    toast.classList.add(`toast-${options.type}`);
    toast.append(icon, content);
  } else {
    const content = document.createElement('div');
    content.classList.add('toast-content');
    content.innerHTML = options.message;

    toast.append(content);
    toast.classList.add('toast-default');
  }

  let time;

  if (options.persistent === true) {
    time = 300000;
  } else if (isFinite(options.time)) {
    time = options.time;
  } else {
    time = 6000;
  }

  setTimeout(() => { toast.classList.add('show'); }, 500);
  setTimeout(() => {
    dismiss();
  }, time);
}
